import { lazy } from "react";
import ProtectedAuth from "./PrivateAuth";
const ComissionSeting = lazy(() =>
  import("../Screens/Main/ComissionSetting/ComissionSeting")
);
const WithdrawalRequest = lazy(() =>
  import("../Screens/Main/WithdrawalRequest/WithdrawalRequest")
);
const WalletTxn = lazy(() => import("../Screens/Main/UserList/WalletTxn"));
const UserList = lazy(() => import("../Screens/Main/UserList/UserList"));
const UserBettings = lazy(() =>
  import("../Screens/Main/UserList/UserBettings")
);
const ChangePassword = lazy(() =>
  import("../Screens/Main/Setting/ChangePassword")
);
const PAymentSetting = lazy(() =>
  import("../Screens/Main/PaymentSetting/PaymentSetting")
);
const FundRequest = lazy(() =>
  import("../Screens/Main/FundRequest/FundRequest")
);
const Dashboard = lazy(() => import("../Screens/Main/Dashboard/Dashboard"));
const Comission = lazy(() => import("../Screens/Main/Comission/Comission"));
const NumberRooms = lazy(() => import("../Screens/Main/NumberGame/Rooms"));
const NumberRoomDetail = lazy(() =>
  import("../Screens/Main/NumberGame/RoomDetail")
);

export const PrivateAuth = () => {
  return [
    {
      element: <ProtectedAuth />,
      children: [
        {
          path: "/dashboard",
          element: <Dashboard />,
        },
        {
          path: "/number-game/rooms",
          element: <NumberRooms />,
        },
        {
          path: "/number-game/room-detail",
          element: <NumberRoomDetail />,
        },
        {
          path: "/user-list",
          element: <UserList />,
        },
        {
          path: "/payment-setting",
          element: <PAymentSetting />,
        },
        {
          path: "/fund-request",
          element: <FundRequest />,
        },
        {
          path: "/fund-request/:id",
          element: <FundRequest />,
        },
        {
          path: "/withdrawal-request",
          element: <WithdrawalRequest />,
        },
        {
          path: "/withdrawal-request/:id",
          element: <WithdrawalRequest />,
        },
        {
          path: "/WalletTxn",
          element: <WalletTxn />,
        },
        {
          path: "/user-bettings",
          element: <UserBettings />,
        },
        {
          path: "/comission",
          element: <Comission />,
        },
        {
          path: "/comission-setting",
          element: <ComissionSeting />,
        },
        {
          path: "/change-password",
          element: <ChangePassword />,
        },
      ],
    },
  ];
};
